import { validateInputType } from "./validateInput";

export const hasCharacter = (string, char) => {

  validateInputType(string, 'string', ['string'], 'hasCharacter')


  return string.includes(char);
};
